import { render, staticRenderFns } from "./p14.vue?vue&type=template&id=2f212b96&scoped=true&"
import script from "./p14.vue?vue&type=script&lang=js&"
export * from "./p14.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f212b96",
  null
  
)

export default component.exports